import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createSession, getSession } from "../../utils/session";
import ShipexLogo from "../../assets/Shipex.jpg"; // adjust path as needed
import illustrationimage from"../../assets/Login.png"; // adjust path as needed
// import axios from "axios";
import { toast } from "react-toastify";
export default function Signup({ setIsAuthenticated }) {
  const [showPassword, setShowPassword] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [error, setError] = useState("");
  const [phoneOtpTimer, setPhoneOtpTimer] = useState(0);
  const [emailOtpTimer, setEmailOtpTimer] = useState(0);
  const [phoneOtp, setPhoneOtp] = useState(new Array(6).fill(""));
  const [emailOtp, setEmailOtp] = useState(new Array(6).fill(""));
  const phoneOtpRefs = useRef([]);
  const emailOtpRefs = useRef([]);
  const [showPhoneOtp, setShowPhoneOtp] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [phoneOtpError, setPhoneOtpError] = useState(false);
  const [emailOtpError, setEmailOtpError] = useState(false);

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const navigate = useNavigate();
  // from data
  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmedPassword: "",
  });

  useEffect(() => {
    const initialize = async () => {
      try {
        const param = new URLSearchParams(window.location.search);
        const token = param.get("token");

        if (token) createSession(token);

        const response = await getSession();
        if (response?.success) {
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.error("Error during session initialization", err);
      }
    };
    initialize();
  }, [setIsAuthenticated]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleTermsChange = (e) => {
    setIsTermsAccepted(e.target.checked);
  };
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError("");
      }, 3000); // 3 seconds

      return () => clearTimeout(timer); // Cleanup function
    }
  }, [error]);

  //send the otp to phone number
  const sendOtp = async () => {
    if (phoneOtpTimer > 0) return; // Prevent spam clicking

    try {
      const response = await fetch(`${REACT_APP_BACKEND_URL}/auth/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phoneNumber: formData.phoneNumber }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to send OTP");
      // console.log("datata", data)
      setShowPhoneOtp(true); // Ensure OTP input appears
      setError("OTP sent to your phone number.");
      // setError(`OTP ${data.otp}`)
      setPhoneOtpTimer(60); // Start 60-sec timer
    } catch (error) {
      console.error("Error sending OTP:", error.message);
      setError("Failed to send OTP. Please try again.");
    }
  };

  const sendEmailOtp = async () => {
    if (emailOtpTimer > 0) return; // Prevent spam clicking

    try {
      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/auth/send-email-otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: formData.email }),
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to send OTP");

      setShowEmailOtp(true); // Ensure OTP input appears
      setError(
        "OTP sent to email.Please check your spam folder as well for the OTP"
      );
      setEmailOtpTimer(60); // Start 60-sec timer
    } catch (error) {
      console.error("Error sending OTP:", error.message);
      setError("Failed to send OTP. Please try again.");
    }
  };

  // Phone OTP input change handler
  const handlePhoneOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...phoneOtp];
    newOtp[index] = value;
    setPhoneOtp(newOtp);

    if (value && index < 5) {
      phoneOtpRefs.current[index + 1].focus();
    }

    // Auto verify when last digit is entered
    if (index === 5 && value) {
      setTimeout(() => verifyPhoneOtp(newOtp.join("")), 300);
    }
  };

  // Email OTP input change handler
  const handleEmailOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...emailOtp];
    newOtp[index] = value;
    setEmailOtp(newOtp);

    if (value && index < 5) {
      emailOtpRefs.current[index + 1].focus();
    }

    // Auto verify when last digit is entered
    if (index === 5 && value) {
      setTimeout(() => verifyEmailOtp(newOtp.join("")), 300);
    }
  };

  // Handle OTP input key events (backspace navigation)
  const handleOtpKeyDown = (index, e, type) => {
    if (e.key === "Backspace" && index > 0 && !e.target.value) {
      if (type === "phone") phoneOtpRefs.current[index - 1].focus();
      if (type === "email") emailOtpRefs.current[index - 1].focus();
    }
  };

  // Verify phone OTP
  const verifyPhoneOtp = async (otp) => {
    try {
      console.log("Verifying Phone OTP:", otp);

      const response = await fetch(`${REACT_APP_BACKEND_URL}/auth/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phoneNumber: formData.phoneNumber,
          otp: otp,
        }),
      });

      const data = await response.json();
      console.log("Phone OTP Response:", data);

      if (!response.ok) throw new Error(data.message || "Invalid OTP");

      setPhoneVerified(true);
      setShowPhoneOtp(false);
    } catch (error) {
      console.error("Phone OTP verification failed:", error.message);
      setPhoneOtpError(true);
      setTimeout(() => setPhoneOtpError(false), 300); // Reset shake effect
    }
  };

  //phone and email otp timer
  useEffect(() => {
    let phoneInterval, emailInterval;

    if (phoneOtpTimer > 0) {
      phoneInterval = setInterval(() => {
        setPhoneOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    if (emailOtpTimer > 0) {
      emailInterval = setInterval(() => {
        setEmailOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      clearInterval(phoneInterval);
      clearInterval(emailInterval);
    };
  }, [phoneOtpTimer, emailOtpTimer]);

  // Verify email OTP
  const verifyEmailOtp = async (otp) => {
    try {
      console.log("Verifying Email OTP:", otp);

      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/auth/verify-email-otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: formData.email,
            otp: otp,
          }),
        }
      );

      const data = await response.json();
      console.log("Email OTP Response:", data);

      if (!response.ok) {
        throw new Error(data.message);
      }

      setEmailVerified(true);
      setShowEmailOtp(false);
    } catch (error) {
      console.error("Email OTP verification failed:", error);
      setEmailOtpError(true);
      setTimeout(() => setEmailOtpError(false), 300); // Reset shake effect
    }
  };
  // Function to shake OTP fields on error
  const shakeOtpFields = (type) => {
    if (type === "phone") {
      phoneOtpRefs.current.forEach((ref) => {
        if (ref) {
          ref.classList.add("shake", "border-red-500");
          setTimeout(
            () => ref.classList.remove("shake", "border-red-500"),
            300
          );
        }
      });
    } else {
      emailOtpRefs.current.forEach((ref) => {
        if (ref) {
          ref.classList.add("shake", "border-red-500");
          setTimeout(
            () => ref.classList.remove("shake", "border-red-500"),
            300
          );
        }
      });
    }
  };

  //  Register the all data
  const registerUser = async () => {
    // e.preventDefault(); // Ensure the event is passed
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.password ||
      !formData.phoneNumber ||
      !formData.companyName ||
      !formData.confirmedPassword
    ) {
      setError("All fields are required.");
      setSuccess(false);
      return;
    }

    if (!phoneVerified || !emailVerified) {
      setError("Email or Phone number is not verified");
      setSuccess(false);
      return;
    }

    try {
      // console.log("Sending registration data:", formData);

      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/external/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fullname: formData.fullName,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            company: formData.companyName,
            monthlyOrders: "0", // Update if needed
            password: formData.password,
            confirmedPassword: formData.confirmedPassword, // Confirmed password
            checked: true,
          }),
        }
      );

      const data = await response.json(); // Convert response to JSON
      // alert(data.message);
      console.log("API Response:", data); // Debugging log

      if (data.success) {
        // alert("User registered successfully!");
        setSuccess(true);
        setError(data.message);
        createSession(data.data);
        setIsAuthenticated(true); // Set authentication state
        // navigate("/login");
      } else {
        // alert("Registration failed: " + data.message);
        setSuccess(false);
        setError(data.message);
      }
    } catch (err) {
      console.error("Error registering user:", err?.response?.data || err);
      setError(
        err?.response?.data?.message ||
          "An error occurred. Please try again later."
      );
      setSuccess(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (
      !formData.fullName ||
      !formData.companyName ||
      !formData.phoneNumber ||
      !formData.email ||
      !formData.password ||
      !formData.confirmedPassword
    ) {
      setError("Please fill in all fields.");
      return;
    }

    if (formData.password !== formData.confirmedPassword) {
      setError("Passwords do not match.");
      return;
    }
    //phone verify
    verifyPhoneOtp();

    verifyEmailOtp();

    registerUser();

    setIsTermsAccepted(false);
  };
  return (
    <div className=" flex-col md:flex-row bg-green-50 flex-grow min-h-screen">
      {/* Left Section - Registration Form */}
<div className="w-full flex flex-row px-4 py-6 md:p-6 justify-center items-center">

        <div className="w-full max-w-sm md:max-w-md lg:max-w-xl p-4 md:p-6 rounded-lg shadow-sm bg-white">
          {/* Logo */}
        <div className="flex justify-between items-center mb-4 md:mb-6">
  <img src={ShipexLogo} alt="Logo" className="h-10 md:h-12" />

  <Link to="/login" className="text-xs text-[#0CBB7D]">
    &lt; <strong>Back</strong>
  </Link>
</div>


          {/* Heading */}
          <h1 className="text-xl md:text-3xl font-bold mb-2 md:mb-3 text-left text-[#0CBB7D]">
            Sign Up Today!
          </h1>
          <p className="text-gray-600 mb-4 text-sm md:text-[12px] font-normal">
            Enter your details to create your account
          </p>

          {/* Error Modal */}
          {error && (
            <>
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-all duration-500 ease-in-out"></div>
              <div className="fixed top-0 left-1/2 transform -translate-x-1/2 mt-4 bg-white shadow-xl border rounded-sm p-4 w-[90%] sm:w-[50%] md:w-[30%] lg:w-[20%] max-w-md flex items-center justify-center text-center z-50">
                <div
                  className={`p-[10px] rounded-md text-[14px] transition-all duration-500 ease-in-out flex justify-center items-center gap-2 ${
                    /success|verified|otp sent|OTP/i.test(error)
                      ? "text-[#0CBB7D] animate-pulse"
                      : "text-red-500 animate-shake"
                  }`}
                >
                  {/success|verified|otp sent|OTP/i.test(error) ? (
                    <span className="text-[#0CBB7D] text-lg">✔</span>
                  ) : (
                    <span className="text-red-500 text-lg">✖</span>
                  )}
                  {error}
                </div>
              </div>
            </>
          )}

          {/* Registration Form Starts */}
          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Back Link */}
           

            {/* Full Name */}
            <div>
              <label className="text-gray-700 text-[12px] font-medium">
                Full Name
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter Full Name"
                required
                className="w-full p-2 border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              />
            </div>

            {/* Company */}
            <div>
              <label className="text-gray-700 text-[12px] font-medium">
                Company
              </label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter Company Name"
                required
                className="w-full p-2 border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              />
            </div>

            {/* Phone Field */}
            <div className="relative">
              <label className="text-gray-700 text-[12px] font-medium">
                Phone
              </label>
              <div className="relative">
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter Phone Number"
                  disabled={phoneVerified}
                  required
                  className="w-full p-2 pr-[85px] border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                />
                <div className="absolute right-2 top-2">
                  {phoneVerified ? (
                    <span className="text-[#0CBB7D] text-[10px] font-medium">
                      ✔ Verified
                    </span>
                  ) : (
                    <div className="relative">
                      <button
                        type="button"
                        onClick={sendOtp}
                        disabled={phoneOtpTimer > 0}
                        className={`absolute -top-2 -right-2 text-[10px] font-medium px-1 py-2.5  rounded-md w-[70px] text-center ${
                          phoneOtpTimer > 0
                            ? "text-gray-500 cursor-not-allowed"
                            : "bg-[#0CBB7D] text-white"
                        }`}
                      >
                        Send OTP
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Phone OTP */}
            {showPhoneOtp && !phoneVerified && (
              <div className="flex items-center gap-2 mt-2">
                <div className="flex gap-1">
                  {phoneOtp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) =>
                        handlePhoneOtpChange(index, e.target.value)
                      }
                      onKeyDown={(e) => handleOtpKeyDown(index, e, "phone")}
                      ref={(el) => (phoneOtpRefs.current[index] = el)}
                      className="w-8 h-8 text-center border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                    />
                  ))}
                </div>
                {phoneOtpTimer > 0 && (
                  <span className="text-xs text-gray-500">
                    Resend OTP in {phoneOtpTimer}s
                  </span>
                )}
              </div>
            )}

            {/* Email Field */}
            <div className="relative">
              <label className="text-gray-700 text-[12px] font-medium">
                Email
              </label>
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Email"
                  disabled={emailVerified}
                  required
                  className="w-full p-2 pr-[85px] border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                />
                <div className="absolute right-2 top-2">
                  {emailVerified ? (
                    <span className="text-[#0CBB7D] text-[10px] font-medium">
                      ✔ Verified
                    </span>
                  ) : (
                    <div className="relative">
                      <button
                        type="button"
                        onClick={sendEmailOtp}
                        disabled={emailOtpTimer > 0}
                        className={`absolute -top-2 -right-2 text-[10px] font-medium px-2 py-2.5 rounded-md w-[70px] text-center ${
                          emailOtpTimer > 0
                            ? "text-gray-500 cursor-not-allowed"
                            : "bg-[#0CBB7D] text-white"
                        }`}
                      >
                        Send OTP
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Email OTP */}
            {showEmailOtp && !emailVerified && (
              <div className="flex items-center gap-2 mt-2">
                <div className="flex gap-1">
                  {emailOtp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) =>
                        handleEmailOtpChange(index, e.target.value)
                      }
                      onKeyDown={(e) => handleOtpKeyDown(index, e, "email")}
                      ref={(el) => (emailOtpRefs.current[index] = el)}
                      className="w-8 h-8 text-center border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                    />
                  ))}
                </div>
                {emailOtpTimer > 0 && (
                  <span className="text-xs text-gray-500">
                    Resend OTP in {emailOtpTimer}s
                  </span>
                )}
              </div>
            )}

            {/* Password */}
            <div className="relative">
              <label className="text-gray-700 text-[12px] font-medium">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter Password"
                required
                className="w-full p-2 pr-10 border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              />
              <span
                onClick={togglePasswordVisibility}
                className="absolute right-3 top-2.5 cursor-pointer text-[#0CBB7D]"
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>

            {/* Confirm Password */}
            <div className="relative">
              <label className="text-gray-700 text-[12px] font-medium">
                Confirm Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="confirmedPassword"
                value={formData.confirmedPassword}
                onChange={handleChange}
                placeholder="Confirm Password"
                required
                className="w-full p-2 pr-10 border rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              />
              <span
                onClick={togglePasswordVisibility}
                className="absolute right-3 top-2.5 cursor-pointer text-[#0CBB7D]"
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>

            {/* Terms Checkbox */}
            <div className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={isTermsAccepted}
                onChange={handleTermsChange}
                className="mt-1"
              />
              <label className="text-[12px] text-gray-700 font-normal">
                By clicking this check box, you accept Shipex's{" "}
                <a href="#" className="text-[#0CBB7D] underline">
                  Terms & Conditions
                </a>{" "}
                &{" "}
                <a href="#" className="text-[#0CBB7D] underline">
                  Privacy Policy
                </a>
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={!isTermsAccepted}
              className={`w-full py-[6px] px-4 text-[14px] rounded-lg transition ${
                isTermsAccepted
                  ? "bg-[#0CBB7D] text-white"
                  : "bg-gray-400 text-gray-200 cursor-not-allowed"
              }`}
            >
              Sign Up
            </button>
          </form>
        </div>
  <div className="hidden md:flex justify-center items-center mt-12 space-x-10 ml-40">
  {/* Right - Image */}
  <img
    src={illustrationimage}
    alt="Delivery Icon"
    className="w-96 h-96 object-contain"
  />
</div>



      </div>

    


      {/* Footer */}
      <div className="w-full bg-white ">
        <footer className="w-full bg-green-50 px-4 py-4 flex flex-col sm:flex-row sm:justify-between sm:items-center text-gray-500 text-[12px] text-center sm:text-left space-y-2 sm:space-y-0 ">
          <p className="w-full sm:w-auto font-normal">
            © 2025 Shipex. All rights reserved.
          </p>

          <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-1 sm:space-y-0 w-full sm:w-auto hidden md:block">
            <a href="#" className="text-gray-500 hover:text-gray-900">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-900">
              Refund & Cancellation Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-900">
              Terms & Conditions
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}
